import { render, staticRenderFns } from "./self.vue?vue&type=template&id=0cf05d0c&scoped=true&"
import script from "./self.vue?vue&type=script&lang=js&"
export * from "./self.vue?vue&type=script&lang=js&"
import style0 from "./self.vue?vue&type=style&index=0&id=0cf05d0c&lang=scss&scoped=true&"
import style1 from "./self.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf05d0c",
  null
  
)

export default component.exports